<template>
    <div style="height:100vh; overflow: hidden;">
        <iframe v-if="url" :src="url" width="100%" height="100%" frameborder="0"></iframe>
    </div>
    
</template>
<script>
export default {
    name:"PDFView",
    props: {
        fileName: {type: String}
    },
    created() {
        let data = null;
        axios.get('chatter/download/template/' + this.fileName, {
          responseType: 'blob',
          headers: { Authorization: accessToken() }
        }).then(response => {
            data = new Blob([response.data], {type: 'application/pdf'});
            this.url = data ? URL.createObjectURL(data) : null;
        });
    },
    data(){
        return {
            url: '',
        }
    }
}
</script>
